/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid } from '@chakra-ui/react';
import VehicleTable from 'views/admin/vehicleDetails/components/vehicleSub/VehicleTable';
import { columnsDataComplex } from 'views/admin/vehicleDetails/variables/columnsData';
import React, { useEffect, useState, useCallback } from 'react';
import VehicleService from '../../../services/VehicleService';

export default function Settings() {

  const [error, setError] = useState('');

  const [tableDataComplex, setVehicleData] = useState([]);

  const getVehicleData = useCallback(async () => {
    try {
      const vehicleData = await VehicleService.getAllVehicles(localStorage.getItem('token'));
      if (vehicleData.status === 201 && vehicleData.data.object) {

        if(error){

        }
        const filteredData = vehicleData.data.object.map(item => ({
          rego: item.registration,
          vinNumber: item.vinNumber,
          make: item.make,
          model: item.model,
          year: item.year,
          category: item.vehicleCategory.category,
          type: item.vehicleType.type,
          status: item.vehicleStatus,
          options: ''
      }));
        setVehicleData(filteredData)
      } else {
        setError(vehicleData.error);
      }
    } catch (error) {
      console.log(error);
      setError(error);
      setTimeout(() => {
        setError('');
      }, 5000);
    }
  },[error]);

  useEffect(() => {
    getVehicleData()
   
  }, [getVehicleData]);

  

  // Chakra Color Mode
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
         {tableDataComplex && tableDataComplex.length > 0 ? (
        <VehicleTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
      ) : (
        <p>No vehicles available</p> // Optional: message when no data is available
      )}
      </SimpleGrid>
    </Box>
  );
}
